import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class ModelsApi {

  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source()

    return Request.get('/models', {
      params: {
        ...options,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async update(data) {
    return Request.put(`/c/models/${data.id}`, data);
  }

  static async remove(data) {
    return Request.delete(`/c/models/${data.id}`);
  }

  static async create(data) {
    return Request.post(`/c/models`, data);
  }
}
